/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdpmEstimatorField } from './PdpmEstimatorField';
import {
    PdpmEstimatorFieldFromJSON,
    PdpmEstimatorFieldFromJSONTyped,
    PdpmEstimatorFieldToJSON,
    PdpmEstimatorFieldToJSONTyped,
} from './PdpmEstimatorField';
import type { PdpmEstimatorFieldReferenceMetaValue } from './PdpmEstimatorFieldReferenceMetaValue';
import {
    PdpmEstimatorFieldReferenceMetaValueFromJSON,
    PdpmEstimatorFieldReferenceMetaValueFromJSONTyped,
    PdpmEstimatorFieldReferenceMetaValueToJSON,
    PdpmEstimatorFieldReferenceMetaValueToJSONTyped,
} from './PdpmEstimatorFieldReferenceMetaValue';

/**
 * 
 * @export
 * @interface PdpmEstimatorFieldReferenceMeta
 */
export interface PdpmEstimatorFieldReferenceMeta {
    /**
     * 
     */
    field: PdpmEstimatorField;
    /**
     * 
     */
    value: PdpmEstimatorFieldReferenceMetaValue;
}



/**
 * Check if a given object implements the PdpmEstimatorFieldReferenceMeta interface.
 */
export function instanceOfPdpmEstimatorFieldReferenceMeta(value: object): value is PdpmEstimatorFieldReferenceMeta {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PdpmEstimatorFieldReferenceMetaFromJSON(json: any): PdpmEstimatorFieldReferenceMeta {
    return PdpmEstimatorFieldReferenceMetaFromJSONTyped(json, false);
}

export function PdpmEstimatorFieldReferenceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdpmEstimatorFieldReferenceMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'field': PdpmEstimatorFieldFromJSON(json['field']),
        'value': PdpmEstimatorFieldReferenceMetaValueFromJSON(json['value']),
    };
}

export function PdpmEstimatorFieldReferenceMetaToJSON(json: any): PdpmEstimatorFieldReferenceMeta {
    return PdpmEstimatorFieldReferenceMetaToJSONTyped(json, false);
}

export function PdpmEstimatorFieldReferenceMetaToJSONTyped(value?: PdpmEstimatorFieldReferenceMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': PdpmEstimatorFieldToJSON(value['field']),
        'value': PdpmEstimatorFieldReferenceMetaValueToJSON(value['value']),
    };
}

